import React, { Component, type ComponentType } from 'react';
import { Anchor } from '@atlaskit/primitives';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { FormattedMessage } from '@atlassian/jira-intl';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import messages from './messages.tsx';

export type Props = {
	readonly unresolvedIssuesCount: number;
	readonly resolvedIssuesCount: number;
	readonly unresolvedIssuesUrl: string;
	readonly resolvedIssueUrl: string;
	readonly doneIssues: number;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	readonly SwapIssues: ComponentType<Record<any, any>>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	readonly ReleaseDate: ComponentType<Record<any, any>>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	readonly ReleaseAutomationBanner: ComponentType<Record<any, any>>;
	readonly intl: IntlShape;
};

// eslint-disable-next-line jira/react/no-class-components
export class Content extends Component<Props> {
	renderDescriptionWithIssues() {
		const {
			intl: { formatMessage },
			unresolvedIssuesCount,
			unresolvedIssuesUrl,
		} = this.props;

		const unresolvedIssueJqlViewLink = (
			<Anchor href={unresolvedIssuesUrl}>
				{formatMessage(
					fg('jira-issue-terminology-refresh-m3')
						? messages.descriptionWithIssuesCountIssueTermRefresh
						: messages.descriptionWithIssuesCount,
					{
						issues: unresolvedIssuesCount,
					},
				)}
			</Anchor>
		);

		return (
			<>
				<FormattedMessage
					{...messages.descriptionWithIssues}
					values={{ issueCountLink: unresolvedIssueJqlViewLink }}
				/>
			</>
		);
	}

	renderDescriptionWithoutIssues() {
		const {
			intl: { formatMessage },
			resolvedIssueUrl,
			resolvedIssuesCount,
		} = this.props;

		const resolvedIssueJqlViewLink = (
			<Anchor href={resolvedIssueUrl}>
				{formatMessage(
					fg('jira-issue-terminology-refresh-m3')
						? messages.descriptionWithoutIssuesIssueTermRefresh
						: messages.descriptionWithoutIssues,
					{
						doneIssues: resolvedIssuesCount,
					},
				)}
			</Anchor>
		);

		return (
			<>
				<FormattedMessage
					{...messages.descriptionWithoutIssuesRestMessage}
					values={{ issueCountLink: resolvedIssueJqlViewLink }}
				/>
			</>
		);
	}

	render() {
		const { unresolvedIssuesCount, SwapIssues, ReleaseDate, ReleaseAutomationBanner } = this.props;

		return (
			<>
				{unresolvedIssuesCount > 0
					? this.renderDescriptionWithIssues()
					: this.renderDescriptionWithoutIssues()}
				{unresolvedIssuesCount > 0 ? <SwapIssues /> : null}
				<ReleaseDate />
				<JSErrorBoundary
					fallback="unmount"
					packageName="jiraSoftwareReleasesVersionDetail"
					teamName="nova"
					id="releaseAutomationBanner"
				>
					<ReleaseAutomationBanner />
				</JSErrorBoundary>
			</>
		);
	}
}

export default injectIntl(Content);
